import React from 'react';
import './Home.css';
import SupportSection from './Support.jsx';
import Footer from '../Footer.jsx';
import FloatingOrderButton from '../../components/FloatingOrderButton';
import laundryImage from '../../assets/moto.png'
import FranchiseTimelineFeature from './Home_HowWork.jsx'
import { useNavigate } from 'react-router-dom';
import FeaturesSection from './FeaturesSection.jsx';
import Testimonials from './Testimonials.jsx';
import dryCleaningImg from '../../assets/dryclean.jpg';
import shoeCleaningImg from '../../assets/shoeclean.jpg';
import sofaCleaningImg from '../../assets/sofacleaning.jpg';
import laundryImg from '../../assets/premiumlaundry.jpg';
import menImg from '../../assets/wash&fold.jpg';
import womenImg from '../../assets/wash&iron.jpg';
import householdImg from '../../assets/household.jpg';
import kidsImg from '../../assets/carpetcleaning.jpg';
import steamironing from '../../assets/steamironing.jpg';
import UpdatesSection from './UpdatesSection.jsx';
import IntroductionSection from './IntroductionSection.jsx';
import HomeServicesGrid from './HomeServicesGrid.jsx';
import Divider from '../Divider.jsx';
import { FaClock, FaShieldAlt, FaLeaf, FaTruck, FaStar, FaUsers, FaAward, FaPhone } from 'react-icons/fa';
import { useAppSelector } from '../../store/hooks';

const services = [
    { title: 'Wash & Fold', desc: 'Efficient and tidy wash-and-fold service designed for your daily wardrobe needs.', img: menImg },
    { title: 'Wash & Iron', desc: 'Impeccably clean and crisply ironed clothes delivered straight to your doorstep.', img: womenImg },
    { title: 'Steam Ironing', desc: 'Smooth out wrinkles and refresh clothes with professional steam ironing.', img: steamironing },
    { title: 'Dry-Cleaning', desc: 'Professional care for all your garments — fresh, crisp, and spotless.', img: dryCleaningImg },
    { title: 'Premium Laundry', desc: 'A luxury laundry experience using premium detergents and expert techniques.', img: laundryImg },
    { title: 'Shoe Cleaning', desc: 'Bring your footwear back to life with our expert shoe cleaning and care services.', img: shoeCleaningImg },
    { title: 'Sofa Cleaning', desc: 'Revitalize your sofas and upholstery with deep cleaning and allergen removal.', img: sofaCleaningImg },
    { title: 'Household', desc: 'Complete care for curtains, bedsheets, and more — we handle the heavy loads.', img: householdImg },
    { title: 'Carpet Cleaning', desc: 'Deep-clean carpets and rugs to remove dust, stains, and allergens with ease.', img: kidsImg }
];

export default function Home() {
  const navigate = useNavigate();
  const stats = useAppSelector((state) => state.stats);

  console.log('Home component - stats from Redux:', stats);

  const handleClick = () => {
    navigate('/franchise#form');
  };

  return (
    <div className="home-container">

      {/* Hero Section */}
      <div className="hero-banner enhanced-hero">
        <div className="hero-overlay">
          <h1 className="fade-in">Fast • Reliable • Trusted Laundry</h1>
          <p className="fade-in delay">We collect. We clean. We deliver. Fresh clothes at your door.</p>
        </div>
      </div>

      <IntroductionSection></IntroductionSection>

      <HomeServicesGrid></HomeServicesGrid>

      {/* <UpdatesSection></UpdatesSection> */}

      {/* Stats Section */}
      <section className="stats-section_1">
        <div className="stats-grid_1">
          <div className="stat-card_1">
            <div className="stat-icon_1"><FaUsers /></div>
            <h3>{stats.customerCount.toLocaleString()}+</h3>
            <p>Happy Customers</p>
          </div>
          <div className="stat-card_1">
            <div className="stat-icon_1"><FaTruck /></div>
            <h3>24hrs</h3>
            <p>Fast Delivery</p>
          </div>
          <div className="stat-card_1">
            <div className="stat-icon_1"><FaStar /></div>
            <h3>4.8★</h3>
            <p>Customer Rating</p>
          </div>
          <div className="stat-card_1">
            <div className="stat-icon_1"><FaAward /></div>
            <h3>{stats.storeCount}+</h3>
            <p>Service Centers</p>
          </div>
        </div>
      </section>

      <Divider topColor="#1e90ff" bottomColor="#1e90ff" thickness="10px" margin="0px 0" />

      <FranchiseTimelineFeature></FranchiseTimelineFeature>
{/* 
      <Divider topColor="#1e90ff" bottomColor="#1e90ff" thickness="10px" margin="0px 0" /> */}

      <section className="motto-section">
        <div className="motto-container">
          <div className="motto-content">
            <div className="motto-header">
              <div className="motto-icon">
                <FaStar />
              </div>
              <h2 className="motto-title">Our <span className="highlight">Motto</span></h2>
              <div className="motto-subtitle">Excellence in Every Thread</div>
            </div>
            
            <div className="motto-text">
              <p className="motto-description">
                At <strong>NeatnClean</strong>, we believe clean clothes aren't just about hygiene—they're about 
                <span className="text-highlight"> confidence, comfort, and care</span>. Our mission is to make laundry 
                effortless, reliable, and refreshingly simple.
              </p>
              
              <div className="motto-features">
                <div className="feature-item">
                  <FaShieldAlt className="feature-icon" />
                  <span>Advanced cleaning technology</span>
                </div>
                <div className="feature-item">
                  <FaLeaf className="feature-icon" />
                  <span>Gentle, eco-friendly detergents</span>
                </div>
                <div className="feature-item">
                  <FaUsers className="feature-icon" />
                  <span>Expert team that cares</span>
                </div>
              </div>
              
              <p className="motto-tagline">
                We ensure your clothes always look their best—<span className="bold-text">so you can, too.</span>
              </p>
            </div>
          </div>
          
          <div className="motto-visual">
            <div className="image-wrapper">
              <img src={laundryImage} alt="Professional Laundry Service" className="motto-image" />
              <div className="image-overlay">
                <div className="overlay-text">
                  <FaAward className="overlay-icon" />
                  <span>Trusted by 10K+ Customers</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <FeaturesSection></FeaturesSection>

      <Divider topColor="#49886b" bottomColor="#49886b" thickness="10px" margin="0px 0" />

      {/* Services Section */}
      {/* <section className="services-section">
        <h2>Our Services</h2>
        <div className="service-card-grid">
          <div className="service-card">
            <img src={washImg} alt="Washing" />
            <h4>Washing</h4>
            <p>Gentle wash cycle tailored to preserve your garments.</p>
          </div>
          <div className="service-card">
            <img src={dryImg} alt="Drying" />
            <h4>Drying</h4>
            <p>Efficient drying using eco-friendly machines.</p>
          </div>
          <div className="service-card">
            <img src={ironImg} alt="Ironing" />
            <h4>Ironing</h4>
            <p>Sharp creases and wrinkle-free clothes for that perfect look.</p>
          </div>
          <div className="service-card">
            <img src={ironImg} alt="Ironing" />
            <h4>Ironing</h4>
            <p>Sharp creases and wrinkle-free clothes for that perfect look.</p>
          </div>
          <div className="service-card">
            <img src={ironImg} alt="Ironing" />
            <h4>Ironing</h4>
            <p>Sharp creases and wrinkle-free clothes for that perfect look.</p>
          </div>
        </div>
      </section> */}

       <section className="services-section">
        <h2>Our Services</h2>
        <div className="services-content">
                <div className="services-grid">
                {services.map((service, idx) => (
                  <div key={idx} className="service-card">
                    <div className="icon">
                      <img src={service.img} alt={service.title} className="service-image" />
                    </div>
                    <h2>{service.title}</h2>
                    <p>{service.desc}</p>
                  </div>
                ))}
              </div>
        </div>
        </section>

      {/* <SupportSection></SupportSection> */}

      <Testimonials></Testimonials>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <h2>Why Choose NeatnClean?</h2>
        <div className="why-choose-grid">
          <div className="why-card">
            <div className="why-icon"><FaClock /></div>
            <h3>24-Hour Service</h3>
            <p>Quick turnaround with same-day pickup and next-day delivery options.</p>
          </div>
          <div className="why-card">
            <div className="why-icon"><FaShieldAlt /></div>
            <h3>Quality Guarantee</h3>
            <p>100% satisfaction guarantee with professional cleaning standards.</p>
          </div>
          <div className="why-card">
            <div className="why-icon"><FaLeaf /></div>
            <h3>Eco-Friendly</h3>
            <p>Environmentally conscious cleaning with biodegradable detergents.</p>
          </div>
          <div className="why-card">
            <div className="why-icon"><FaPhone /></div>
            <h3>24/7 Support</h3>
            <p>Round-the-clock customer support for all your laundry needs.</p>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <h2>How It Works</h2>
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <h3>Schedule Pickup</h3>
            <p>Book online or call us to schedule a convenient pickup time.</p>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <h3>We Collect</h3>
            <p>Our team collects your clothes from your doorstep.</p>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <h3>Professional Cleaning</h3>
            <p>Expert cleaning using premium detergents and equipment.</p>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <h3>Fresh Delivery</h3>
            <p>Clean, folded clothes delivered back to your door.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="testimonials-section curved-section">
        <h2>Loved By Thousands</h2>
        <div className="testimonial-block">
          <div className="testimonial">
          <img src={customer1} alt="Customer 1" />
            <h4>Ritika Sinha</h4>
            <p>"Laundry used to be my weekend killer. Now I’m free — thanks to Cleanz24!"</p>
          </div>
          <div className="testimonial">
          <img src={customer1} alt="Customer 1" />
            <h4>Amit Kapoor</h4>
            <p>"Timely pickup & delivery, neat folding, and great support!"</p>
          </div>
          <div className="testimonial">
          <img src={customer1} alt="Customer 1" />
            <h4>Pooja R.</h4>
            <p>"This is the best service I’ve used in Delhi NCR. Absolute peace of mind!"</p>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Provide Hassle-Free Laundry Today!</h2>
        <p>Book your first service and get 15% OFF on your first order.</p>
        <button onClick={handleClick}>Want Franchise!!</button>
      </section>
      <Footer/>
      <FloatingOrderButton />
    </div>
  );
}
  